module.exports = __webpack_public_path__ + "media/images/emoticons/atm-0de2342a4309711e61314f6ad4b6524d.gif";